import { MarkNode } from '@lexical/mark'
import { ListItemNode, ListNode } from '@lexical/list'
import { HeadingNode, QuoteNode } from '@lexical/rich-text'
import { LinkNode } from '@lexical/link'
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table'

import { CitationNode } from './Nodes/CitationNode/CitationNode'

export const LEXICAL_NODES = [MarkNode, HeadingNode, ListNode, ListItemNode, QuoteNode, LinkNode, TableNode, TableCellNode, TableRowNode]

export const CITATION_LEXICAL_NODES = [...LEXICAL_NODES, CitationNode]
